const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

async function notificationFetch(path, options = {}) {
  const token = localStorage.getItem('developmentexpress_token');
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token || ''}`,
      ...(options.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.message || 'Request failed');
  }
  return data;
}

export function getPushNotificationPreference() {
  return notificationFetch('/api/notifications/preferences');
}

export function setPushNotificationPreference(enabled) {
  return notificationFetch('/api/notifications/preferences', {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
}
